import React from 'react';
import './Highlights.css';

const Highlights = () => {
    // Sample data for the highlights
    const projectData = {
        assignedProjects: 125,
        stats: [
            { name: 'Completed', count: 50, color: 'completed', trend: 'up' },
            { name: 'Working', count: 50, color: 'working', trend: 'up' },
            { name: 'Hold', count: 25, color: 'hold', trend: 'down' },
            { name: 'Cancel', count: 25, color: 'cancel', trend: 'up' }
        ]
    };

    // Calculate progress bar widths and percentages based on actual data
    const total = projectData.stats.reduce((sum, stat) => sum + stat.count, 0);
    const progressWidths = projectData.stats.map(stat => (stat.count / total) * 100);
    
    // Update stats with calculated percentages
    const statsWithPercentages = projectData.stats.map((stat, index) => ({
        ...stat,
        percentage: Math.round(progressWidths[index])
    }));

    return (
        <div className='c-card-1 h-100 highlights-section'>
            <div className="c-card-header-1">
                Highlights
            </div>
            <div className="c-card-body-1">
                <div className='p-tag'>Assign Project</div>
                <div className='fs-30 fw-bold mt-2'>{projectData.assignedProjects}</div>
                
                {/* Progress Bar */}
                <div className="d-flex justify-content-between align-items-center mt-3 rounded-5 overflow-hidden">
                    {statsWithPercentages.map((stat, index) => (
                        <div 
                            key={stat.name}
                            className={`progress bg-${stat.color}`} 
                            style={{ width: `${progressWidths[index]}%` }}
                        ></div>
                    ))}
                </div>
                
                {/* Progress Labels */}
                <div className="d-flex mt-3">
                    {statsWithPercentages.map((stat) => (
                        <div key={stat.name} className="p-tag me-3">
                            <span className={`dots bg-${stat.color} rounded-circle`}></span> 
                            {stat.name}
                        </div>
                    ))}
                </div>
                
                <hr/>
                
                {/* Detailed Stats */}
                {statsWithPercentages.map((stat) => (
                    <div key={stat.name} className='d-flex justify-content-between align-items-center mt-2'>
                        <div className="p-tag">{stat.name}</div>
                        <div className='d-flex align-items-center gap-2'>
                            <div className="p-tag fw-bold me-3">{stat.count}</div>
                            <div className="p-tag fw-bold">
                                <i className={`fa fa-arrow-${stat.trend === 'up' ? 'up' : 'down'} ${stat.trend === 'up' ? 'text-success' : 'text-danger'} me-2`}></i>
                                {stat.percentage}%
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Highlights;
